import { atom } from "recoil";

const phoneAtom = atom<string | null>({
  key: "phone",
  default: null,
});

export default phoneAtom;
